import ListingLibTableActions from 'framework-listing-lib/table/ListingLibTableActions';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import useUpdateTableColumns from '../hooks/useUpdateTableColumns';
import { jsx as _jsx } from "react/jsx-runtime";
const TableActions = ({
  additionalTableActions
}) => {
  const [updateTableColumns, {
    loading: updateTableColumnsLoading
  }] = useUpdateTableColumns();
  const handleSaveCustomColumns = ({
    columns
  }) => {
    updateTableColumns(columns).then(() => {
      // TODO: display success banner
    }).catch(() => {
      // TODO: display error banner
    });
    listingLibObserver.closeEditColumnsModal();
  };
  return /*#__PURE__*/_jsx(ListingLibTableActions, {
    editColumnProps: {
      loading: updateTableColumnsLoading,
      onSave: handleSaveCustomColumns,
      staticColumns: [CONTENT_PLATFORM_PROPERTY_NAME.NAME]
    },
    children: additionalTableActions
  });
};
export default TableActions;